import { gsap } from 'gsap';
import { getKeyboardFocusableElements } from '../utils';

export default class Collapse {
	constructor(el) {
		this.el = el;
		this.content = el.querySelector('[data-collapse-content]');
		this.toggleButton = el.querySelector('[data-collapse-toggle]');

		this.toggleButton?.addEventListener('click', (e) => {
			this.isOpen ? this.close() : this.open();
		});

		if (!this.isOpen) {
			getKeyboardFocusableElements(this.content).forEach((element) => (element.tabIndex = -1));
		} else {
			this.open(true);
		}
	}

	static init() {
		document.addEventListener('bless', (e) => {
			e.target.querySelectorAll('[data-collapse]').forEach((el) => new Collapse(el));
		});
	}

	get isOpen() {
		return this.el.classList.contains('is-open');
	}

	open(instantly = false) {
		if (this.animating) {
			return;
		}

		const prev = this.el.previousElementSibling;
		const next = this.el.nextElementSibling;

		next?.classList.add('prev-is-open');
		prev?.classList.add('next-is-open');

		const tl = gsap.timeline({
			onStart: () => {
				this.animating = true;
				this.el.classList.add('is-open');
			},
			onComplete: () => {
				this.animating = false;
				this.toggleButton?.setAttribute('aria-expanded', true);
				this.el.dispatchEvent(new CustomEvent('collapse-opened', { detail: { el: this.el }, bubbles: true }));
			},
		});

		tl.fromTo(
			this.content,
			{
				height: 0,
			},
			{
				height: this.content.scrollHeight,
				ease: 'power2.inOut',
				duration: instantly ? 0 : 0.4,
			}
		);

		tl.fromTo(
			this.content,
			{
				opacity: 0,
			},
			{
				opacity: 1,
				ease: 'none',
				duration: instantly ? 0 : 0.4,
			}
		);

		getKeyboardFocusableElements(this.content).forEach((element) => element.removeAttribute('tabindex'));
	}

	close(instantly = false) {
		if (this.animating) {
			return;
		}

		const prev = this.el.previousElementSibling;
		const next = this.el.nextElementSibling;

		next?.classList.remove('prev-is-open');
		prev?.classList.remove('next-is-open');

		const tl = gsap.timeline({
			onStart: () => {
				this.animating = true;
				this.el.classList.remove('is-open');
			},
			onComplete: () => {
				this.animating = false;
				this.toggleButton?.setAttribute('aria-expanded', false);
			},
		});

		tl.fromTo(
			this.content,
			{
				opacity: 1,
			},
			{
				opacity: 0,
				ease: 'none',
				duration: instantly ? 0 : 0.2,
			}
		);

		tl.fromTo(
			this.content,
			{
				height: this.content.scrollHeight,
			},
			{
				height: 0,
				ease: 'power2.inOut',
				duration: instantly ? 0 : 0.4,
			}
		);

		getKeyboardFocusableElements(this.content).forEach((element) => (element.tabIndex = -1));
	}
}
